import { Resources } from 'constants/resources';

import * as React from 'react';

import { useGoBack } from 'hooks/useGoBack';
import { queryClient } from 'providers/queryClient';
import { DeleteDialog, DeleteDialogProps } from 'shared/mui/Dialogs';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { truncateString } from 'utils/truncateString';

export const CommissionsDeleteDialog: React.FC<Omit<DeleteDialogProps, 'details' | 'title'>> = (
  props,
) => {
  const { goBack } = useGoBack();

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: [Resources.Commissions] });
    goBack();
  };

  return (
    <DeleteDialog
      {...props}
      details={
        <>
          Комиссия{' '}
          <TypographyBold fontSize={16} text={truncateString(props.record?.name || '', 50)} /> будет
          удалена без возможности восстановления.
        </>
      }
      onSuccess={onSuccess}
      title="Удаление комиссии"
    />
  );
};
